import React from 'react';
import { Redirect } from 'react-router-dom';

import loadable from '../../shared/utils/loadable';

// Code splitting!

const SettingsApp = loadable(() => import('../App'));

const General = loadable(() => import('../containers/General'));
const Password = loadable(() => import('../containers/Password'));
const PostRegistrationForm = loadable(() => import('../containers/PostRegistrationForm'));
const Preferences = loadable(() => import('../containers/Preferences'));
const Integrations = loadable(() => import('../containers/Integrations'));

const routes = [{
	path: '/settings',
	component: SettingsApp,
	routes: [{
		path: '/settings/password',
		component: Password
	}, {
		path: '/settings/post-register',
		component: PostRegistrationForm
	}, {
		path: '/settings/preferences',
		component: Preferences
	}, {
		path: '/settings/general',
		component: General
	}, {
		path: '/settings/integrations',
		component: Integrations
	}, {
		path: '/settings',
		exact: true,
		component: () => <Redirect to="/settings/general" />,
	}]
}];

export default routes;
